<template>
  <content-dialog
    :visible.sync="modalVisible"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :small-title="$vuetify.breakpoint.xsOnly"
    max-width="400px"
  >
    <!--<editor-fold desc="Dialog Title">-->
    <template slot="dialogTitle">
      <div class="mb-2">
        Revoke {{ inventoryItemIssued.inventory_item.label }} from {{ inventoryItemIssued.staff.name }}
      </div>
    </template>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Content">-->
    <v-card-text :class="{'pa-4': $vuetify.breakpoint.smAndUp }">
      <v-text-field
        v-model="amount"
        v-validate="{
          required: true,
          decimal: true,
          max_value: inventoryItemIssued.amount,
          min_value: 0.01
        }"
        name="amount"
        min="0"
        :max="inventoryItemIssued.amount"
        data-vv-as="amount"
        type="number"
        outlined
        label="Amount"
        hint="Amount that's being revoked from the employee"
        :error-messages="veeErrors.collect('amount')"
        :suffix="inventoryItemIssued.inventory_item.unit"
        autocomplete="disable"
        persistent-hint
      />
    </v-card-text>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Actions">-->
    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :loading="submitting"
        @click="submit"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Submit
      </v-btn>
    </template>
    <!--</editor-fold>-->
  </content-dialog>
</template>

<script>
  import ContentDialog from '@/components/helpers/Dialog'
  import InventoryItem from '@/models/InventoryItem'
  import validationScrollMixin from '@/mixins/validationScrollMixin'

  export default {
    name: 'InventoryIssuedRevokeDialog',
    components: {
      ContentDialog
    },
    mixins: [
      validationScrollMixin
    ],
    props: {
      visible: Boolean,
      inventoryItemIssued: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        amount: this.inventoryItemIssued.amount,
        submitting: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      }
    },
    watch: {
      inventoryItemIssued: function () {
        this.amount = this.inventoryItemIssued.amount
      }
    },
    methods: {
      async submit() {
        let validation = await this.$validator.validateAll()

        if (!validation) {
          this.showAlertAndScrollToFirstError()
          return
        }

        this.revokeIssuedItem()
      },
      async revokeIssuedItem() {
        this.submitting = true

        const formData = {
          inventory_item_id: this.inventoryItemIssued.inventory_item_id,
          staff_id: this.inventoryItemIssued.staff_id,
          amount: this.amount
        }

        try {
          await InventoryItem.api.revokeIssued(formData)

          this.$store.dispatch('alert', {
            'text': 'Successfully revoked issued item.',
            'color': 'success'
          })

          this.$validator.reset()

          this.$emit('inventoryItemIssued:revoked')

          this.modalVisible = false
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>
